import React from 'react';
import './RaidCard.css';

const RaidCard = ({ raid }) => {
  const {
    id,
    requiredLevel,
    requiredGearScore = 0,
    memberCount,
    maxMemberCount,
    leaderLeadership,
    leaderName
  } = raid;


  return (
    <div className="raid-card">
      <div className="raid-card-background">
        <div className="raid-card-content">
          <div className="raid-requirement">
            <span className="requirement-label">Level {requiredLevel}/{requiredGearScore} point(s)</span>
          </div>
          
          <div className="raid-members">
            <span className="member-count">{memberCount}/{maxMemberCount}</span>
          </div>
          
          <div className="raid-leader-info">
            <div className="leader-name">{leaderName}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RaidCard;
